import { Injectable } from '@angular/core';
import { Task } from 'src/core/master-data/domain/task';
import { TaskRepository } from 'src/core/tasks/domain/task-repository';

@Injectable({
  providedIn: 'any',
})
export class GetTask {
  constructor(private readonly taskRepository: TaskRepository) {}

  // Only fetches the task: whether it is stored as the temporary task is up to the caller, which is the
  // one deciding if the task can be opened at all.
  async execute(id: string): Promise<Task> {
    return await this.taskRepository.get(id);
  }
}
